import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

import NancyMartino from "../../assets/employee.jpg";
import Tushar from "../../assets/Tushar.webp";
import Shivani from "../../assets/shivani.jpeg";
import priyanka from "../../assets/priyanka.jpeg";
import istak from "../../assets/istak.jpeg";
import krishna from "../../assets/krishna.jpeg";

export default function OurTeam() {


  // Array of team members matching your image layout
  const teamMembers = [
    { name: "Tushar Suryawanshi", role: "Director / CEO", url: Tushar },
    { name: "Shivani Suryawanshi", role: "Director", url: Shivani },
    { name: "Saurabh Kadam", role: "Manager", url: NancyMartino },
    { name: "Priyanka Mole", role: "HR",url: priyanka },
    { name: "Istak Shaikh", role: "Developer", url: istak },
    { name: "Krishna Poul", role: "Developer", url: krishna },
  ];

  return (
    <section id="team" className="py-5" style={{ backgroundColor: "#f3f6f9" }}>
      <Container className="py-5">
        {/* 1. Header Text Section */}
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <h2 className="fw-bold text-dark mb-3">
              Our <span style={{ color: "#f06548" }}>Team</span>
            </h2>
            <p className="text-secondary px-lg-5 fs-6">
              To achieve this, it would be necessary to have uniform grammar,
              pronunciation and more common words. If several languages coalesce
              the grammar.
            </p>
          </Col>
        </Row>

        {/* 2. Team Cards Grid System */}
        <Row className="g-4 mb-5">
          {teamMembers.map((member, index) => (
            <Col key={index} lg={3} md={6} sm={12}>
              <Card className="border-0 shadow-sm rounded-3 py-4 text-center h-100 position-relative bg-white">
                {/* Profile Image Wrapper */}
                <div
                  className="position-relative d-inline-block mx-auto mb-3"
                  style={{ width: "110px", height: "110px" }}
                >
                  <img
                    src={member.url}
                    alt={member.name}
                    className="img-fluid rounded-circle"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>

                {/* Card Body Content */}
                <Card.Body className="p-0">
                  <h5 className="fw-bold text-dark mb-1 fs-5">{member.name}</h5>
                  <p className="text-muted small mb-0 fw-medium">
                    {member.role}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* 3. Bottom Central Navigation Action Button */}
        {/* <Row className="text-center">
          <Col>
            <Button
              style={{ backgroundColor: "#405189", borderColor: "#405189" }}
              className="px-4 py-2 fw-medium shadow-sm"
            >
              View All Members <span className="ms-1">→</span>
            </Button>
          </Col>
        </Row> */}
      </Container>
    </section>
  );
}
